export const DEFAULT_TIME_ZONE_OFFSET = '-7';

export const parseTimeToMinutes = (time) => {
    if (!time || typeof time !== 'string') return null;
    const [hours, minutes] = time.split(':').map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
};

export const validateTimeRange = ({ startTime, endTime }) => {
    const startMinutes = parseTimeToMinutes(startTime);
    const endMinutes = parseTimeToMinutes(endTime);
    if (startMinutes === null || endMinutes === null || startMinutes >= endMinutes) {
        return {
            valid: false,
            message: 'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc',
        };
    }

    return { valid: true };
};

export const hasOperatingHourOverlap = (candidate, operatingHours = [], currentIndex = -1) => {
    if (!candidate?.isActive) return false;

    const candidateStart = parseTimeToMinutes(candidate.startTime);
    const candidateEnd = parseTimeToMinutes(candidate.endTime);

    return operatingHours.some((item, index) => {
        if (index === currentIndex || !item?.isActive) return false;

        const existingStart = parseTimeToMinutes(item.startTime);
        const existingEnd = parseTimeToMinutes(item.endTime);

        if (candidateStart === null || candidateEnd === null || existingStart === null || existingEnd === null) {
            return false;
        }

        return candidateStart <= existingEnd && candidateEnd >= existingStart;
    });
};

export const validateOperatingHour = (candidate, operatingHours = [], currentIndex = -1) => {
    const timeRangeValidation = validateTimeRange(candidate);
    if (!timeRangeValidation.valid) {
        return timeRangeValidation;
    }

    if (hasOperatingHourOverlap(candidate, operatingHours, currentIndex)) {
        return {
            valid: false,
            message: 'Khung giờ bị trùng hoặc chồng lấp với khung giờ khác',
        };
    }

    return { valid: true };
};
